import { IApi, useClientApi } from '@/setup/api-client'
import { useApiMutation } from '@/utils/api/api-mutation'
import type {
    CreditTopupCheckoutData,
    CreditTopupCheckoutBody,
} from 'api/dist/routes/organization/[organization_id]/credits/top-up/checkout'

export class CreateTopupCheckoutMutation {
    static async call(
        api: IApi,
        organizationId: string,
        body: CreditTopupCheckoutBody
    ): Promise<CreditTopupCheckoutData> {
        return api
            .post<
                CreditTopupCheckoutData,
                CreditTopupCheckoutBody
            >(`/organization/${organizationId}/credits/top-up/checkout`, body)
            .then((res) => res.data)
    }
}

export const useCreateTopupCheckoutMutation = (organizationId: string) => {
    const api = useClientApi()

    return useApiMutation({
        mutationFn: (body: CreditTopupCheckoutBody) => CreateTopupCheckoutMutation.call(api, organizationId, body),
    })
}

export type ITopupCheckoutData = CreditTopupCheckoutData
export type ITopupCheckoutBody = CreditTopupCheckoutBody
